export default __webpack_public_path__ + "static/media/step_2_image.91f43927.png";